import Alpine from "alpinejs";

document.addEventListener("alpine:init", () => {});

Alpine.data("disponibilities", () => {
    return {
        waitingTime: "",
        healthInsuranceCoverage: "yes",
        teleconsultationType: "all",
        get visibleDisponibilities() {
            const isInitialFilters =
                this.waitingTime === this.$refs.waitingTimeInput.max;
            if (isInitialFilters) {
                return disponibilities;
            }
            return (
                disponibilities
                    .filter(this.filterByWaitingTime.bind(this))
                    // .filter(this.filterByHealthInsuranceCoverage)
                    .filter(this.filterByTeleconsultationType.bind(this))
                    .sort(this.sortByWaitingTime)
            );
        },
        init() {
            this.waitingTime = this.$refs.waitingTimeInput.value;
        },
        isVisible(disponibilityId) {
            return this.visibleDisponibilities.find(
                (disponibility) => disponibility.id === disponibilityId
            );
        },
        filterByWaitingTime(disponibility) {
            if (disponibility.form_to_fill === 1) {
                return true;
            }
            return (
                Number.parseFloat(disponibility.temps_attente / 60) <=
                Number.parseFloat(this.waitingTime)
            );
        },
        filterByHealthInsuranceCoverage(disponibility) {
            // TODO
        },
        filterByTeleconsultationType(disponibility) {
            if (this.teleconsultationType === "video") {
                return disponibility.visio_only === 1;
            }
            if (this.teleconsultationType === "form") {
                return disponibility.form_to_fill === 1;
            }
            if (this.teleconsultationType === "phone") {
                return disponibility.phonecall === 1;
            }
            // this.teleconsultationType === "all"
            return true;
        },
        sortByWaitingTime(disponibilityA, disponibilityB) {
            return disponibilityA.temps_attente - disponibilityB.temps_attente;
        },
    };
});

window.Alpine = Alpine;

Alpine.start();
